import React from 'react';

import { Link } from 'react-router-dom';

import { BreadcrumbsSeparatorIcon } from 'components/common/Icons/common/BreadcrumbsSeparatorIcon/BreadcrumbsSeparatorIcon';
import classes from 'components/common/PageBreadcrumbs/PageBreadcrumbs.module.scss';
import { BreadcrumbLabel } from 'components/common/PageBreadcrumbs/components/BreadcrumbLabel';

/** One entry in the breadcrumb trail (a link or plain text for the current page). */
export interface BreadcrumbItem {
    /** Text shown for this segment. */
    label?: string;
    /** When set, the segment is a `react-router-dom` `Link` to this path; omit on the current page so it renders as non-clickable text. */
    to?: string;
    /** Ellipsis effect is default, When noEllipsis is true, long labels are not truncated with an ellipsis. */
    noEllipsis?: boolean;
}

interface Props {
    /** Ordered trail from root to current context; the last item is usually the current page without `to`. */
    items: BreadcrumbItem[];
}

export const PageBreadcrumbs = ({ items }: Props) => {
    return (
        <nav className={classes.breadcrumbsContainer}>
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <span className={classes.separator}>
                                <BreadcrumbsSeparatorIcon />
                            </span>
                        )}
                        {item.to ? (
                            <Link
                                className={`${classes.breadcrumbItem} ${classes.clickable} ${item.noEllipsis ? classes.noEllipsis : ''}`}
                                to={item.to}
                            >
                                <BreadcrumbLabel
                                    label={item.label ?? ''}
                                    isLastBreadCrumb={isLast}
                                    noEllipsis={item.noEllipsis}
                                />
                            </Link>
                        ) : (
                            <span className={`${classes.breadcrumbItem} ${item.noEllipsis ? classes.noEllipsis : ''}`}>
                                <BreadcrumbLabel
                                    label={item.label ?? ''}
                                    isLastBreadCrumb={isLast}
                                    noEllipsis={item.noEllipsis}
                                />
                            </span>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};
